import type { CatalogCard } from '../helpers/mapCatalog'

export const PRODUCT_INFO_SECTIONS = {
  contains: 'Product Contains',
  description: 'Description',
  care: 'Care Instructions',
  sku: 'SKU Number',
} as const

export const PRODUCT_OPTION_SECTIONS = {
  stem: 'Choose option',
  wrapper: 'Choose Wrapper',
  addons: 'Add-on Gifts',
} as const

export const PRODUCT_RELATED = {
  title: 'You may also like',
  subtitle: 'Recommended from the same collection',
  /** One desktop row. Wider grids are 5 columns; extra cards wrap. */
  limit: 5,
} as const

export const PRODUCT_PAGE_UI = {
  notFound: 'Product not found',
  backHome: '← Back to home',
  inStock: 'In Stock',
  verified: 'Verified',
  reviews: 'reviews',
} as const

/** Keys read from product/variant content jsonb for storefront info sections. */
export const PRODUCT_CONTENT_KEYS = {
  shortDescription: ['shortDescription'] as const,
  description: ['description'] as const,
  contains: ['contains', 'includes', 'productContains'] as const,
  care: ['careInstructions', 'care'] as const,
} as const

export type ProductCardGridProps = {
  products: CatalogCard[]
}

export type RelatedProductsState = {
  products: CatalogCard[]
  loading: boolean
}
